import { useInfiniteQuery } from '@tanstack/react-query';
import { unwrap, type VariationStatus } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

const PAGE_SIZE = 20;

export const variationsListKeys = {
  all: ['variations-list'] as const,
  list: (
    siteId: number | undefined,
    status: VariationStatus | undefined,
    isAuthenticated: boolean
  ) =>
    [...variationsListKeys.all, { siteId, status, isAuthenticated }] as const,
};

export function useVariationsList(siteId?: number, status?: VariationStatus) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useInfiniteQuery({
    queryKey: variationsListKeys.list(siteId, status, isAuthenticated),
    queryFn: async ({ pageParam, signal }) =>
      unwrap(
        await api.legacy.GET('/api/v1/variations', {
          params: {
            query: { siteId, status, page: pageParam, pageSize: PAGE_SIZE },
          },
          signal,
        })
      ),
    initialPageParam: 1,
    getNextPageParam: page => (page.hasMore ? page.page + 1 : undefined),
    enabled: isAuthenticated,
    staleTime: 30000,
  });
}
